import { Button, Dialog, DialogContent } from "@sentricmusic/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import useGetColours from "@/helpers/getColours";
import { useUIStateStore } from "@/store/uiStateStore";

type SingleWriterWarningModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function SingleWriterWarningModal({
  isOpen,
  onClose,
  onConfirm,
}: SingleWriterWarningModalProps) {
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);
  const isTunecore = useUIStateStore(state => state.isTunecore);
  const { t } = useTranslation(["songs", "common"]);
  const { highlightColour } = useGetColours();

  const handleConfirm = () => {
    if (doNotShowAgain) {
      localStorage.setItem("showWriterWarning", "false");
    }
    onConfirm();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <div className={`flex flex-col justify-between min-h-80 sm:min-h-48 ${
          isTunecore ? "text-white" : "text-black font-sentric"
        }`}
        >
          <div>
            <h2 className="mb-4 text-lg">
              {t("songs:single-writer-warning-header")}
            </h2>
            <p className="mb-6">
              {t("songs:single-writer-warning-description")}
            </p>
          </div>

          <div className="mb-6">
            <input
              style={{
                accentColor: highlightColour,
              }}
              type="checkbox"
              className={`mr-3 lg:scale-125 ${
                isTunecore ? "text-tunecore-blue" : ""
              }`}
              id="doNotShowAgain"
              checked={doNotShowAgain}
              onChange={() => setDoNotShowAgain(!doNotShowAgain)}
            />
            <label htmlFor="doNotShowAgain">
              {t("common:dont-show-again")}
            </label>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <Button
            variant="outline"
            onClick={onClose}
            label={t("common:take-me-back-button")}
          />
          <Button
            onClick={handleConfirm}
            label={t("common:i-understand-button")}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
